export default {
  CURRENCY_SETTING_SET_LOADING: 'CURRENCY_SETTING_SET_LOADING',

  CURRENCY_SETTING_REQUEST: 'CURRENCY_SETTING_REQUEST',
  CURRENCY_SETTING_FAILURE: 'CURRENCY_SETTING_FAILURE',
  CURRENCY_SETTING_SUCCESS: 'CURRENCY_SETTING_SUCCESS',

  CURRENCY_SETTING_RESET: 'CURRENCY_SETTING_RESET',
};
